import { useAuth0 } from "@auth0/auth0-react";
import { Licensing_V1 } from "@rw1/auto-generated-clients";
import { useAppConfig, useEnvConfig } from "rwo-react";
import { setAccessTokenProvider } from "./accessTokenProvider";
import { joinUrl } from ".";

let licensingClientV1: Licensing_V1.LicensingClientV1 | undefined;

export const useLicensingServiceV1 = (): Licensing_V1.LicensingClientV1 => {
  const { getAccessTokenSilently } = useAuth0();
  const { backendAddress } = useEnvConfig();
  const { config } = useAppConfig();

  licensingClientV1 ??= new Licensing_V1.LicensingClientV1(
    joinUrl(backendAddress, config["LicensingApiSuffix"])
  );
  setAccessTokenProvider(licensingClientV1, getAccessTokenSilently);

  return licensingClientV1;
};
